import expenseItem from '@/api/expense-item'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return expenseItem.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return expenseItem.store(data)
  },

  async find(context, id) {
    return await expenseItem.find(id)
  },

  update(context, data) {
    return expenseItem.update(data)
  },

  delete(context, id) {
    return expenseItem.destroy(id)
  }
}
